import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import TestimonialsPanel from '../TestimonialsPanel'
import WhyDoWeChargeAFee from '../WhyDoWeChargeAFee'
import Cookies from 'universal-cookie'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import { shouldTranslateTo } from '../../utils/utils'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import moment from 'moment'
import {
  Title,
  Subtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const CenterSmallMargin = styled(Center)`
  margin: 70px auto 50px;
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitleDiscount = styled(OnboardingSubtitle)`
  background-color: #ffff00;
  border-radius: 5px;
  padding: 10px;
  color: #000;

  span {
    color: #ff0000;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  font-size: 18px;
  margin: 24px 20px 30px 20px;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 60px;

  & > div {
    flex-basis: 50%;
  }

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBox = styled.div`
  background-color: #fff;
  /*
  box-shadow: ${(props) => (props.shadow ? '0 5px 9px -2px #b5b5b5;' : 'none')};
  border: 1px solid #a5a5a5;
  */
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
`

const PriceBoxHeader = styled.div`
  background-color: #000a84;
  padding: 6px;
`

const PriceBoxHeaderBadgeContainer = styled.div`
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  height: 70px;
  width: 70px;
  padding: 2px 0 0 0;
  position: absolute;
  top: -16px;
  right: -10px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 126%;
  margin: 16px 0 0;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 30px auto 34px;
  width: 170px;
  position: relative;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const PriceFreeSubtitle = styled(PriceSubtitle)`
  margin: 0;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: ${(props) => (props.color ? props.color : '#6a6a6a')};
  font-weight: 600;
  letter-spacing: 0px;
  margin: 0 0 0 2px;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
`

const ChoiceButton = styled(ActionButtons)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const ChoiceLoadingButton = styled(LoadingButton)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
  padding: 10px 30px;
`

const ChoiceLoadingButtonInactive = styled(ChoiceButton)`
  background-color: #fff;
  cursor: default !important;
`

const TestimonialsWrapper = styled.div`
  margin: 0;
`

const PriceBoxList = styled.ul`
  margin: 0 1vw 40px;

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PblI = styled.li`
  margin: 0 0 24px 20px;
  position: relative;

  &::before {
    content: url('images/onboarding/tick-green.svg');
    font-size: 20px;
    position: absolute;
    left: -30px;
    width: 24px;
  }
`

const PblIn = styled(PblI)`
  &::before {
    content: url('images/onboarding/cross-red.svg');
  }
`

const PriceSubtitleStrike = styled(Subtitle)`
  color: #ff0000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  position: absolute;
  top: -20px;
  font-size: 20px;
  text-decoration: line-through;
`

const ChooseSubscriptionOnboarding = ({ data, onComplete }) => {
  const [currencySign, setCurrencySign] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [loading, setLoading] = useState('')
  const [membershipFees, setMembershipFees] = useState([19.9, 29.9, 47.9])
  const [discountMessage, setDiscountMessage] = useState('')
  const [discountCode, setDiscountCode] = useState('')
  const [discounted, setDiscounted] = useState(false)
  const [discountAmount, setDiscountAmount] = useState('')
  const [discountType, setDiscountType] = useState('')
  const [discountMembershipFeeQuarterly, setDiscountMembershipFeeQuarterly] =
    useState(19.9)
  const [discountMonthlyAmountQuarterly, setDiscountMonthlyAmountQuarterly] =
    useState(6.63)
  const [discountMembershipFeeSemiAnnual, setDiscountMembershipFeeSemiAnnual] =
    useState(29.9)
  const [discountMonthlyAmountSemiAnnual, setDiscountMonthlyAmountSemiAnnual] =
    useState(4.98)
  const [discountMembershipFeeAnnual, setDiscountMembershipFeeAnnual] =
    useState(47.9)
  const [discountMonthlyAmountAnnual, setDiscountMonthlyAmountAnnual] =
    useState(3.99)
  const [monthlyDivisor, setMonthlyDivisor] = useState([3, 6, 12])

  const leftRef = useRef(null)
  const middleRef = useRef(null)
  const rightRef = useRef(null)

  useEffect(() => {
    setTimeout(function () {
      //scrollIntoView(actionRef)
    }, 1000)
  }, [])

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()

    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  useEffect(() => {
    var discountCodeValue = ''

    console.log('cookies.get(dc): ' + cookies.get('dc'))

    if (cookies.get('dc')) {
      discountCodeValue = cookies.get('dc')
      console.log('discountCodeValue: ' + discountCodeValue)
    } else if (data.auth.user.voucherCode) {
      discountCodeValue = data.auth.user.voucherCode
    }

    if (discountCodeValue) {
      axios
        .get(`api/discount-voucher/${discountCodeValue}`)
        .then((response) => {
          console.log('>>>>>>>>>> response: ' + JSON.stringify(response))

          if (Object.keys(response.data).length > 0) {
            if (
              moment() >= moment(response.data.startDate) &&
              moment() <= moment(response.data.endDate).add(1, 'days')
            ) {
              setDiscounted(true)
              setDiscountCode(discountCodeValue)
              setDiscountAmount(response.data.discountAmount)
              setDiscountType(response.data.discountUnit)

              console.log('============================================')
              console.log(
                'discount: ' +
                  (
                    membershipFees[0].toFixed(2) *
                      (response.data.discountAmount / 100) +
                    0.0001
                  ).toFixed(2)
              )

              if (response.data.discountUnit === 'PER') {
                // Quarterly discounted amount
                setDiscountMembershipFeeQuarterly(
                  (
                    membershipFees[0].toFixed(2) -
                    (
                      membershipFees[0].toFixed(2) *
                        (response.data.discountAmount / 100) +
                      0.0001
                    ).toFixed(2)
                  ).toFixed(2)
                )

                setDiscountMonthlyAmountQuarterly(
                  (
                    (
                      membershipFees[0].toFixed(2) -
                      (
                        membershipFees[0].toFixed(2) *
                          (response.data.discountAmount / 100) +
                        0.0001
                      ).toFixed(2)
                    ).toFixed(2) / monthlyDivisor[0]
                  ).toFixed(2)
                )

                // Semi-Annual discounted amount
                setDiscountMembershipFeeSemiAnnual(
                  (
                    membershipFees[1].toFixed(2) -
                    (
                      membershipFees[1].toFixed(2) *
                        (response.data.discountAmount / 100) +
                      0.0001
                    ).toFixed(2)
                  ).toFixed(2)
                )

                setDiscountMonthlyAmountSemiAnnual(
                  (
                    (
                      membershipFees[1].toFixed(2) -
                      (
                        membershipFees[1].toFixed(2) *
                          (response.data.discountAmount / 100) +
                        0.0001
                      ).toFixed(2)
                    ).toFixed(2) / monthlyDivisor[0]
                  ).toFixed(2)
                )

                // Annual discounted amount
                setDiscountMembershipFeeAnnual(
                  (
                    membershipFees[2].toFixed(2) -
                    (
                      membershipFees[2].toFixed(2) *
                        (response.data.discountAmount / 100) +
                      0.0001
                    ).toFixed(2)
                  ).toFixed(2)
                )

                setDiscountMonthlyAmountAnnual(
                  (
                    (
                      membershipFees[2].toFixed(2) -
                      (
                        membershipFees[2].toFixed(2) *
                          (response.data.discountAmount / 100) +
                        0.0001
                      ).toFixed(2)
                    ).toFixed(2) / monthlyDivisor[0]
                  ).toFixed(2)
                )

                setDiscountMessage(
                  'Discount code ' +
                    ' <span>' +
                    discountCodeValue +
                    '</span> ' +
                    ' has been added. Prices have been discounted by ' +
                    ' <span>' +
                    response.data.discountAmount +
                    '%</span>.'
                )
              }
            } else {
              setDiscounted(false)
            }
          } else {
            setDiscounted(false)
          }
        })
        .catch((err) => {
          console.log('Error getting discount code: ', err)
          setDiscounted(false)
        })
    } else {
      setDiscounted(false)
    }
  }, [])

  useEffect(() => {
    function handleResize() {
      handleResizeColumns()
    }
    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    /*
    function handleLoad() {
      console.log('handleLoad...')
      handleResizeColumns()
    }
    window.addEventListener('load', handleLoad)
    */
    if (
      currencySign &&
      pageText.length !== 0 &&
      data.auth.user.membershipFeeStatus !== 'completed'
    ) {
      handleResizeColumns()
    }
  }, [currencySign, pageText])

  const handleResizeColumns = () => {
    leftRef.current.style.minHeight = `auto`
    middleRef.current.style.minHeight = `auto`
    rightRef.current.style.minHeight = `auto`

    const leftHeight = leftRef.current.getBoundingClientRect().height
    const middleHeight = middleRef.current.getBoundingClientRect().height
    const rightHeight = rightRef.current.getBoundingClientRect().height

    if (leftHeight >= middleHeight && leftHeight >= rightHeight) {
      middleRef.current.style.minHeight = `${leftHeight}px`
      rightRef.current.style.minHeight = `${leftHeight}px`
    } else if (middleHeight >= leftHeight && middleHeight >= rightHeight) {
      leftRef.current.style.minHeight = `${middleHeight}px`
      rightRef.current.style.minHeight = `${middleHeight}px`
    } else if (rightHeight >= leftHeight && rightHeight >= middleHeight) {
      leftRef.current.style.minHeight = `${rightHeight}px`
      middleRef.current.style.minHeight = `${rightHeight}px`
    }
  }

  const handleSetPriceButton = (e, fee, option) => {
    e.preventDefault()

    var membershipFee = 0.0
    var userData = {}

    setLoading(option)

    cookies.set('dtd', true, { path: '/' })

    if (discounted) {
      if (option === 'quarterly') {
        membershipFee = discountMembershipFeeQuarterly
        cookies.set('dtdoamt', discountMembershipFeeQuarterly, { path: '/' })
        cookies.set(
          'dtdoamtmnth',
          discountMembershipFeeQuarterly / monthlyDivisor[0],
          {
            path: '/',
          }
        )
      } else if (option === 'semi-annual') {
        membershipFee = discountMembershipFeeSemiAnnual
        cookies.set('dtdoamt', discountMembershipFeeSemiAnnual, { path: '/' })
        cookies.set(
          'dtdoamtmnth',
          discountMembershipFeeSemiAnnual / monthlyDivisor[1],
          {
            path: '/',
          }
        )
      } else if (option === 'annual') {
        membershipFee = discountMembershipFeeAnnual
        cookies.set('dtdoamt', discountMembershipFeeAnnual, { path: '/' })
        cookies.set(
          'dtdoamtmnth',
          discountMembershipFeeAnnual / monthlyDivisor[2],
          {
            path: '/',
          }
        )
      }

      userData = {
        membershipFee: membershipFee,
        subscriptionType: option,
        discount: discountAmount,
        discountType: discountType,
        voucherCode: discountCode,
      }
    } else {
      if (option === 'quarterly') {
        membershipFee = membershipFees[0].toFixed(2)
      } else if (option === 'semi-annual') {
        membershipFee = membershipFees[1].toFixed(2)
      } else if (option === 'annual') {
        membershipFee = membershipFees[2].toFixed(2)
      }

      userData = {
        membershipFee: membershipFee,
        subscriptionType: option,
        discount: null,
        discountType: null,
        voucherCode: null,
      }
    }

    cookies.set('uD', userData, { path: '/' })

    setTimeout(function () {
      if (option !== 'freemium') {
        onComplete('mp2')
      } else {
        verifyAccountStatus(data, 'choosesubscription')
        onComplete('db')
      }
      setLoading('')
    }, 1000)

    /*
    data.auth.updateUser(userData).then(() => {
      setTimeout(function () {
        option !== 'freemium' ? onComplete('mp2') : onComplete('db')
        setLoading('')
      }, 1000)
    })
      */
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        <ContainerBox>
          {data.auth.user.membershipFeeStatus === 'completed' ? (
            <>
              <Title
                center
                color="#fff"
                size="29px"
                sizemd="29px"
                sizesm="24px"
                margin="0 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `Membership plan : ${data.auth.user.subscriptionType === 'freemium' ? 'Visitor' : 'Paying member'}`,
                }}
              ></Title>
              <Subtitle
                center
                color="#fff"
                weight="400"
                size="20px"
                margin="20px 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[12]} ${currencySign}${(Math.round(data.auth.user.membershipFee * 100) / 100).toFixed(2)}`,
                }}
              />
            </>
          ) : (
            <div>
              <OnboardingTitle
                center
                color="#ff9900"
                size="34px"
                sizemd="34px"
                sizesm="34px"
                margin="10px 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[21]}`,
                }}
              ></OnboardingTitle>

              <OnboardingSubtitle
                center
                color="#fff"
                size="20px"
                sizesm="20px"
                weight="700"
                margin="20px 0 50px"
                dangerouslySetInnerHTML={{
                  __html: `Please choose your preferred membership plan.`,
                }}
              />

              {discounted && (
                <OnboardingSubtitleDiscount
                  center
                  color="#fff"
                  size="20px"
                  sizesm="20px"
                  weight="700"
                  margin="20px 0 50px"
                  dangerouslySetInnerHTML={{
                    __html: `${discountMessage}`,
                  }}
                />
              )}

              <FlexRowPrice>
                <PriceBoxHeaderBadgeContainer>
                  {data.auth.user.subscriptionType === 'freemium' && (
                    <PriceBoxHeaderBadge>
                      {' '}
                      <PriceHeaderBadgeSubtitle
                        center
                        size="28px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Current plan`,
                        }}
                      />
                    </PriceBoxHeaderBadge>
                  )}
                  <PriceBox shadow>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Visitor`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice>
                      <PriceContainer>
                        {/*}
                      <CurrencySubtitle
                        center
                        size="16px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${currencySign}`,
                        }}
                      />
                      */}
                        <PriceFreeSubtitle
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `FREE`,
                          }}
                        />
                        <PriceDurationSubtitle
                          color="#fff"
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `FOREVER`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo>
                      <PriceBoxList ref={leftRef}>
                        <PblI>Limited access to Community Hub</PblI>
                        <PblI>
                          Engage with other users in open Community spaces
                        </PblI>
                        <PblI>
                          Share travel tips and participate in discussions
                        </PblI>
                        <PblI>Receive newsletter & community updates</PblI>
                        <PblIn>Direct messaging with other users</PblIn>
                        <PblIn>
                          Arrange meet-ups with locals and fellow travelers
                        </PblIn>
                        <PblIn>Book homestays or become a host</PblIn>
                        <PblIn>Find travel buddies</PblIn>
                        <PblIn>Access to member events</PblIn>
                        <PblIn>
                          Access to travel partner offers & discounts
                        </PblIn>
                      </PriceBoxList>
                      {data.auth.user.subscriptionType === 'freemium' ||
                      (data.auth.user.subscriptionType === 'freemium' &&
                        loading === 'quarterly') ||
                      (data.auth.user.subscriptionType === 'freemium' &&
                        loading === 'annual') ? (
                        <ChoiceLoadingButtonInactive
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                        >
                          Current plan
                        </ChoiceLoadingButtonInactive>
                      ) : loading === 'freemium' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 0, 'freemium')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 0, 'freemium')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                </PriceBoxHeaderBadgeContainer>

                <PriceBoxHeaderBadgeContainer>
                  {data.auth.user.subscriptionType === 'quarterly' && (
                    <PriceBoxHeaderBadge>
                      {' '}
                      <PriceHeaderBadgeSubtitle
                        center
                        size="28px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Current plan`,
                        }}
                      />
                    </PriceBoxHeaderBadge>
                  )}
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Member 3 Month`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice>
                      <PriceContainer>
                        {discounted ? (
                          <>
                            <PriceSubtitleStrike
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}${membershipFees[0].toFixed(2)}`,
                              }}
                            />
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${discountMembershipFeeQuarterly}`,
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${membershipFees[0].toFixed(2)}`,
                              }}
                            />
                          </>
                        )}

                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[25]}`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo>
                      <PriceBoxList ref={middleRef}>
                        <PblI>Full access to Community Hub</PblI>
                        <PblI>
                          Engage with other users in open and members-only
                          Community spaces
                        </PblI>
                        <PblI>
                          Share travel tips and participate in discussions
                        </PblI>
                        <PblI>Receive newsletter & community updates</PblI>
                        <PblI>
                          Direct messaging with other verified members
                        </PblI>
                        <PblI>
                          Arrange meet-ups with locals and fellow travelers
                        </PblI>
                        <PblI>Book homestays or become a host</PblI>
                        <PblI>Plan trips with the help of willing locals</PblI>

                        <PblI>Find travel buddies</PblI>
                        <PblI>Access to member events</PblI>
                        <PblI>Access to travel partner offers & discounts</PblI>
                      </PriceBoxList>
                      {data.auth.user.subscriptionType === 'quarterly' ? (
                        <ChoiceLoadingButtonInactive
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                        >
                          Current plan
                        </ChoiceLoadingButtonInactive>
                      ) : loading === 'quarterly' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 19.9, 'quarterly')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 19.9, 'quarterly')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                </PriceBoxHeaderBadgeContainer>

                <PriceBoxHeaderBadgeContainer>
                  {data.auth.user.subscriptionType === 'annual' && (
                    <PriceBoxHeaderBadge>
                      {' '}
                      <PriceHeaderBadgeSubtitle
                        center
                        size="28px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Current plan`,
                        }}
                      />
                    </PriceBoxHeaderBadge>
                  )}
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Member 12 Month`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice>
                      <PriceContainer>
                        {discounted ? (
                          <>
                            <PriceSubtitleStrike
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}${membershipFees[2].toFixed(2)}`,
                              }}
                            />
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${discountMembershipFeeAnnual}`,
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${membershipFees[2].toFixed(2)}`,
                              }}
                            />
                          </>
                        )}

                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[33]}`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo>
                      <PriceBoxList ref={rightRef}>
                        <PblI>Full access to Community Hub</PblI>
                        <PblI>
                          Engage with other users in open and members-only
                          Community spaces
                        </PblI>
                        <PblI>
                          Share travel tips and participate in discussions
                        </PblI>
                        <PblI>Receive newsletter & community updates</PblI>
                        <PblI>
                          Direct messaging with other verified members
                        </PblI>
                        <PblI>
                          Arrange meet-ups with locals and fellow travelers
                        </PblI>
                        <PblI>Book homestays or become a host</PblI>
                        <PblI>Plan trips with the help of willing locals</PblI>

                        <PblI>Find travel buddies</PblI>
                        <PblI>Access to member events</PblI>
                        <PblI>Access to travel partner offers & discounts</PblI>
                      </PriceBoxList>
                      {data.auth.user.subscriptionType === 'annual' ? (
                        <ChoiceLoadingButtonInactive
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                        >
                          Current plan
                        </ChoiceLoadingButtonInactive>
                      ) : loading === 'annual' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 47.9, 'annual')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 47.9, 'annual')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                </PriceBoxHeaderBadgeContainer>
              </FlexRowPrice>

              <CenterSmallMargin>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </CenterSmallMargin>

              <PriceChoiceSubtitle
                center
                size="28px"
                margin="0 0 10px 1%"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[22]}`,
                }}
              />

              <PriceChoiceSubtitle
                center
                size="28px"
                margin="0 0 10px 1%"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[23]}`,
                }}
              />

              {/* Testimonials */}
              <TestimonialsWrapper>
                <TestimonialsPanel
                  color="transparent"
                  textcolor="#fff"
                  showintro={true}
                  numbertoshow={10}
                />
              </TestimonialsWrapper>

              {/* Trust & Security / ID */}
              <WhyDoWeChargeAFee
                pageText={pageText}
                pageText2={pageText2}
                color={'transparent'}
                textcolor="#fff"
              />

              <Center>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </Center>
            </div>
          )}
        </ContainerBox>
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChooseSubscriptionOnboarding))
